export default "__VITE_ASSET__7f4037bf__"